import { BRAND_HAS_CONTROL_OVER_RATINGS } from 'common/configuration/constants';

/**
 * The graph typename of a series.
 *
 * common/ cannot read it from the EntityTypename enum of website/types: an enum is
 * a runtime value, and the website alias is only wired for the website bundle, so
 * importing it breaks the userspace build. Only types can cross that boundary.
 */
export const SERIES_TYPENAME = 'Series';

/**
 * A series is never bound by a review: it airs over years, so neither "is it
 * released" nor a single release date says anything useful about it.
 *
 * If the entity tells whether it is released (isReleased, read from the graph
 * releaseFlags.release.global): a released entity can be rated without a review,
 * an unreleased one needs one. This is the reliable answer, and the only one for
 * the entities which have no release date at all.
 *
 * Otherwise we guess it from the dates. If the film has a theatrical release date :
 *
 * in the past: rating possible without review
 * in the future: mandatory review
 * If the film has no theatrical release date :
 *
 * and the year of production is >= 3 years from today (e.g., an old film with no exact theatrical release date):
 * rating is possible without review,
 * and the year of production is < 3 years from today
 * (e.g., the film will be released soon, but we don't really know when):
 * mandatory review.
 *
 * @param entity
 */
export const isBoundByAReview = (
  entity?: {
    typename?: string;
    isReleased?: boolean | null;
    releaseDate?: string | Date | null;
    productionYear?: number | null;
    hasMandatoryReview?: boolean;
  } | null
) => {
  if (entity?.hasMandatoryReview) return true;
  if (!BRAND_HAS_CONTROL_OVER_RATINGS) return false;

  if (entity?.typename === SERIES_TYPENAME) return false;

  if (typeof entity?.isReleased === 'boolean') return !entity.isReleased;

  const today = new Date();
  return Boolean(
    entity?.releaseDate
      ? new Date(entity.releaseDate) > today
      : entity?.productionYear &&
          entity.productionYear > today.getFullYear() - 3
  );
};
